const RecruitingFooter = () => {
  return (
    <>
      <h5>WHY THIS MATTERS</h5>
      <p>
        There are numerous active trials at any given time that are not accepting new patients, as well as future trials that have not
        started recruiting.
      </p>
    </>
  );
};

export default RecruitingFooter;
